module.exports = __webpack_public_path__ + "media/components/components/booking/KidsSafety/assets/cradle-flyo-43b92eab56c0b17d0b1ddfd47e2acf1b.svg";